import { offerTabSettings } from '../../navigation/NavMenuData'
import { getOfferTabLink } from '../index'
import { GetOfferNavigationLinkPropertiesInterface } from './getOfferNavigationLink.types'

// TODO: think about function name
// TODO: think about refactor all place with `getOfferTabLink`
export const getOfferNavigationLink = ({ active, advertiserAlias, model }: GetOfferNavigationLinkPropertiesInterface) =>
  getOfferTabLink(advertiserAlias, model, active ? offerTabSettings.links : offerTabSettings.activation)
